module.exports = __webpack_public_path__ + "img/untitled.495.6b012c92.png";